import React, { useState, useEffect } from 'react';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
import { UI_TEXT } from '../constants';
import LanguageIcon from '@mui/icons-material/Language';
import { useOptions } from '../context/optionContext';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Stack
} from '@mui/material';

function Language() {
  const { t } = useTranslation();
  const { optionKeys } = useOptions();
  const supportedLanguages = ['en', 'fr', 'es', 'de'];
  const languageTranslationEnabled = optionKeys?.enableLanguageTranslation !== "false";

  const [language, setLanguage] = useState(() => {
    const currentLang = i18n.language || 'en';
    return supportedLanguages.includes(currentLang) ? currentLang : 'en';
  });

  const changeLanguage = (lng) => {
    if (supportedLanguages.includes(lng)) {
      i18n.changeLanguage(lng);
    }
  };

  useEffect(() => {
    if (!languageTranslationEnabled) return;
    const currentLang = i18n.language;
    if (!supportedLanguages.includes(currentLang)) {
      i18n.changeLanguage('en');
    } else {
      setLanguage(currentLang);
    }
  }, [i18n.language, languageTranslationEnabled]);

  if (!languageTranslationEnabled) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant='body2' color="textSecondary">
        {t('UI_TEXT.LANGUAGE')}{" "}<LanguageIcon fontSize="small" color="action" />
      </Typography>
      <FormControl
        size="small"
        sx={{ minWidth: 140 }}
      >
        <Select
          labelId="language-select-label"
          id="language-select"
          value={language}
          onChange={(e) => changeLanguage(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              border: "none",
              height: "30px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
            "& .MuiInput-root": {
              height: "30px",
            }, width: 100,
            height: "30px",
            color: '#4f4f4f',
          }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="fr">French</MenuItem>
          <MenuItem value="es">Spanish</MenuItem>
          <MenuItem value="de">German</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default Language;
